<template>
	<div class="sala-box" @mouseover="hover=true" @mouseout="hover=false" >
	
		
		<img :src="'/images/SALA/'+info.image" />

		<div class="front-cover" v-if="info.imageCredit">
			<p class="credit"><i>Art Credit: {{info.imageCredit}}</i></p>
		</div>

 		<transition name="karta-swap">
			<div v-if="hover" class="back-cover">
				<div class="text-overlay">
					<span class="titleName" v-if="info.title">{{info.title}}</span><br/>
					
					<template v-if="info.group">
						<span class="groupName">{{info.group}}</span>
					</template>
					<template v-else>
						<template v-if="info.artist.length>2">
							<label class="artistName">Mixed Group</label>
						</template>
						<template v-else>
		 					<template v-for="(artist, index) in info.artist">
								<label class="artistName" v-if="index>0">,</label>
								<label class="artistName">{{artist}}</label>
							</template>
						</template>
					</template>
					
 					<template v-if="info.overideAddress">
 						<hr/><a :href="'https://www.google.com.au/maps/search/'+info.overideAddress" target="_blank">
 						<span class="venueTitle"><i class="fas fa-map-marker-alt"></i></span><br/>
						<span class="venue">{{info.venue}}</span><br/>
						<span class="address" v-if="info.address">{{info.address}}, {{info.suburb}}</span></a>
 					</template>
 					<template v-else>
	 					<template v-if="info.venue">
	 						<hr/><a :href="'https://www.google.com.au/maps/search/'+info.venue+' '+info.address.replace('\/','%2f')+', '+info.suburb" target="_blank">
	 						<span class="venueTitle"><i class="fas fa-map-marker-alt"></i></span><br/>
							<span class="venue">{{info.venue}}</span><br/>
							<span class="address" v-if="info.address">{{info.address}}, {{info.suburb}}</span></a>
						</template>
					</template>

					<template v-if="info.website2"><p class="url" ><a target="_blank" :href="info.website2">Download Map</a></p></template>

					<template v-if="info.website3"><p class="url" ><a target="_blank" :href="info.website3">View Guide</a></p></template>

					<template v-if="info.website4"><p class="url" ><a target="_blank" :href="info.website4">Visit Website for more details</a></p></template>

					<template v-if="info.website"><p class="url" ><a target="_blank" :href="info.website">More details on SALA website</a></p></template>

				</div>
			</div>
		</transition>
	</div>
</template>	
<script>

	export default {
		props: {
			info: {}
		},
		data() {
			return {
				hover: false	
			}
			
		}
	}

</script>
<style>
	.sala-box { 
		position: relative;
		margin: 0 3px;
	}
	.sala-box .front-cover { position:absolute; bottom:7px; right:0; background:rgba(0,0,0,.3); color:#ccc; font-size: .8em; text-align: right; padding:.3em; padding-right: 1em;}
	.sala-box .back-cover { 
		text-align: center;
		position:absolute; 
		top:0; left:0; bottom:6px;
		width:100%;
		/*height: 100%;*/
		background: rgba(0,0,0,.8); 
		display: flex;
    	align-items: center;
    	justify-content: center;
    	resize: both;
    	overflow: auto;
	}

	.sala-box .text-overlay { 
		background: rgba(23,196,238,.5); 
		color: #fff;
		resize:both;
		overflow: auto;
		padding: 2em;
		width:90%;
		border-radius: 3px;
		border-bottom-right-radius: 30px;
	}

	@media screen and (max-width: 1216px) and (min-width: 769px) {
		.sala-box .text-overlay {
			font-size: .7em;
			width:80%;
		}
	}
	.sala-box .text-overlay hr { margin:0; margin-top: .5em; margin-bottom: .3em; }

	.sala-box .text-overlay .titleName { font-size: 2em; line-height: 1em; font-weight: bold; }
	.sala-box .text-overlay .venueTitle { font-size: 2.2em; font-weight: bold; }
	.sala-box .text-overlay .venue { font-size: 1.2em; font-weight: bold; }


	.sala-box .text-overlay .url { padding:.7em; margin-top: .5em; background: rgba(23,196,238,.8); font-size: .8em; font-weight: bold; }
	.sala-box .text-overlay .url a { color: #fff; }
	.sala-box .text-overlay .url a:hover { color: #333; }

	.sala-box img { 
		transition: transform .3s;
	}
	.sala-box img:hover { 
 		-webkit-transform: scale(1.02);
        -ms-transform: scale(1.02);
        transform: scale(1.02);

        -webkit-transform: rotateZ(-1deg);
        -ms-transform: rotateZ(-1deg);
        transform: rotateZ(-1deg);		

	}

	.karta-leave-active {
	}
	.karta-leave {
	}
	.karta-leave-to {
	}


	.karta-swap-enter-active {
		transition: all .4s cubic-bezier(1.0, 0.0, 0.8, 1.0);
	}
	.karta-swap-enter {
		transform: rotateX(90deg);
		opacity: 0;
	}
	.karta-swap-enter-to {

		top: 100%;
	  	position: relative;
	  	transition: all .3s ease-out;
	  	background: #428bca;
	  	height: 100%;
		opacity: .8;

	}



</style>


// WEBPACK FOOTER //
// resources/assets/js/components/events/sala/Card.vue